import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Image from "../components/image"
import HeroSection from "../components/HeroSection"

const IndexPage = () => (
  <Layout>
    <SEO title="Explor The World, Travel More" />
    <HeroSection />
    <Image />
  </Layout>
)

export default IndexPage
